/**
GLOBALS FOR ALL PROJECTS
*/

/**Commenti si o no! */
var rTComment = 0;
/**Test mode si, no*/
var rTTest = 0;

export { rTComment, rTTest };

